import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteSellVariableProps extends ModalEditComponentProps { }

const ModalDeleteSellVariable: React.FC<ModalDeleteSellVariableProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/sell/sellVariable/updateSellVariable',
        data: {
            id: allRowData?.id,
            active: false
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteSellVariable', '¿Seguro quieres eliminar esta variable de venta?'),
            subtitle: t('onceDeletedNotRecoverF', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

export default ModalDeleteSellVariable